var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHandshake(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 100,
    viewBox: "0 0 100 100",
    width: 100,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m65.648 27.4a15.636 15.636 0 0 0 4.229-10.644c0-8.919-8.511-16.149-17.877-16.149s-16.964 7.23-16.964 16.148a15.688 15.688 0 0 0 4.76 11.2l-1.049 4.952 5.092-1.991a17.645 17.645 0 0 0 16.785-.27l5.686 2.261z",
    stroke: "#636a6f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m50.049 26-6.11-4.583 2.774-3.277 3.017 2.616 7.959-12.84 3.7 2.141-9.981 15.7a.888.888 0 0 1 -1.206.35.857.857 0 0 1 -.153-.107z",
    stroke: "#ff5a00"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#636a6f"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m.868 7.439 28.979 28.98-18.384 18.384-10.607-10.606"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m28.787 72.127-10.96-10.96 18.031-18.031 6.961 6.964a14.93 14.93 0 0 0 -.8 1.471l-3.629 7.653a3.965 3.965 0 0 0 -.028 3.334"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m25.428 75.486 5.657-5.657a3.75 3.75 0 0 1 5.3 0l.354.354a3.75 3.75 0 0 1 0 5.3l-5.657 5.657a3.75 3.75 0 0 1 -5.3 0l-.354-.354a3.947 3.947 0 0 1 0-5.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m31.085 81.143 5.657-5.657a3.75 3.75 0 0 1 5.3 0l.354.354a3.75 3.75 0 0 1 0 5.3l-5.654 5.66a3.752 3.752 0 0 1 -5.3 0l-.353-.354a3.749 3.749 0 0 1 0-5.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m36.742 86.8 5.658-5.657a3.75 3.75 0 0 1 5.3 0l.353.354a3.749 3.749 0 0 1 0 5.3l-5.653 5.66a3.752 3.752 0 0 1 -5.3 0l-.353-.354a3.748 3.748 0 0 1 -.006-5.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m71.92 71.42 4.066 4.066a3.749 3.749 0 0 1 0 5.3l-.353.354a3.752 3.752 0 0 1 -5.3 0l-3.358-3.359"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m66.971 77.784 3.358 3.359a3.749 3.749 0 0 1 0 5.3l-.353.354a3.752 3.752 0 0 1 -5.3 0l-3.358-3.359"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m61.314 83.441 3.358 3.359a3.749 3.749 0 0 1 0 5.3l-.353.354a3.75 3.75 0 0 1 -5.3 0l-3.362-3.354"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m55.657 89.1 3.359 3.359a3.75 3.75 0 0 1 0 5.3l-.354.354a3.75 3.75 0 0 1 -5.3 0l-2.652-2.652"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m42.4 92.457 5.655-5.657a3.75 3.75 0 0 1 5.3 0l.353.353a3.75 3.75 0 0 1 0 5.3l-5.657 5.657a3.75 3.75 0 0 1 -5.3 0l-.351-.35a3.749 3.749 0 0 1 0-5.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m65.203 41.368 6.717-6.717 21.921 21.92-6.718 6.718z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m99.144 44.197-8.839 8.839-16.97-16.971 25.153-25.154"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m8.281 57.985 23.688-23.688 6.364 6.364-23.688 23.688z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m83.588 59.753-11.665 11.665-7.147-7.032a48.467 48.467 0 0 0 -11.45-8.366l-1.347-.708a2.345 2.345 0 0 0 -3.155.971l-3.531 6.527a3.853 3.853 0 0 1 -5.212 1.59c-.039-.021-.079-.043-.118-.066a3.953 3.953 0 0 1 -1.576-5.109l3.629-7.653a14.269 14.269 0 0 1 18.858-6.94l3.232 1.368 2.865-2.865z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHandshake);
export default __webpack_public_path__ + "static/media/handshake.5e470ea8319e5239f2687d5e02b62841.svg";
export { ForwardRef as ReactComponent };